module.exports = __webpack_public_path__ + "img/vector_dark.52231e2d.svg";